/**
 * Left titles on the process Troubleshooting block and the how-it-works FAQ
 * use the same entrance as “Give a new look”: letters unblur in a random order.
 */
(function () {
  'use strict';

  if (!document.documentElement || document.documentElement.dataset.leavesTitleReveal === '1') return;
  document.documentElement.dataset.leavesTitleReveal = '1';

  var EASE = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
  var TITLES = [
    '.leaves-process-faq__title',
    '.leaves-hiw-faq__title',
  ];
  var QUESTIONS = [
    '.leaves-process-faq .leaves-own-faq summary > span',
    '.leaves-hiw-faq .leaves-own-faq summary > span',
  ];
  var TITLE_TIME = { blur: 320, duration: 420, step: 22 };
  var QUESTION_TIME = { blur: 100, duration: 150, step: 4 };

  function reduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function splitChars(title) {
    var text = title.textContent || '';
    title.textContent = '';
    var line = document.createElement('span');
    line.className = 'lst-line';
    Array.prototype.forEach.call(text, function (char) {
      var span = document.createElement('span');
      span.className = 'lst-char';
      span.innerHTML = char === ' ' ? '&nbsp;' : escapeHtml(char);
      line.appendChild(span);
    });
    title.appendChild(line);
    title.classList.add('leaves-title-reveal');
  }

  function showChars(title) {
    Array.prototype.forEach.call(title.querySelectorAll('.lst-char'), function (ch) {
      ch.style.opacity = '1';
      ch.style.filter = 'none';
    });
  }

  function playTitle(title, timing) {
    if (title.dataset.played === '1') return;
    title.dataset.played = '1';
    if (reduced()) {
      showChars(title);
      return;
    }
    title.animate([{ opacity: 0, filter: 'blur(12px)' }, { opacity: 1, filter: 'blur(0px)' }], {
      duration: timing.blur,
      easing: EASE,
      fill: 'forwards',
    });
    var chars = Array.prototype.slice.call(title.querySelectorAll('.lst-char'));
    var order = chars.map(function (_, index) {
      return index;
    });
    for (var i = order.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var swap = order[i];
      order[i] = order[j];
      order[j] = swap;
    }
    chars.forEach(function (ch, index) {
      ch.animate([{ opacity: 0, filter: 'blur(12px)' }, { opacity: 1, filter: 'blur(0px)' }], {
        duration: timing.duration,
        delay: order[index] * timing.step,
        easing: EASE,
        fill: 'forwards',
      });
    });
  }

  function bind(title, timing) {
    if (!title || title.dataset.revealReady === '1') return;
    title.dataset.revealReady = '1';
    splitChars(title);
    if (reduced()) {
      showChars(title);
      return;
    }
    if (!('IntersectionObserver' in window)) {
      playTitle(title, timing);
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio < 0.4) return;
          playTitle(title, timing);
          observer.disconnect();
        });
      },
      { threshold: [0, 0.4] }
    );
    observer.observe(title);
  }

  function run() {
    TITLES.forEach(function (selector) {
      bind(document.querySelector(selector), TITLE_TIME);
    });
    QUESTIONS.forEach(function (selector) {
      Array.prototype.forEach.call(document.querySelectorAll(selector), function (node) {
        if ((node.textContent || '').trim().length < 2) return;
        bind(node, QUESTION_TIME);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
